export default "__VITE_ASSET__dGaZRfnJ__"